import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomePageModule) },
  {
    path: 'details-demande-agent',
    loadChildren: () => import('./details-demande-agent/details-demande-agent.module').then(m => m.DetailsDemandeAgentModule),
  },
  {
    path: 'details-gardiennage',
    loadComponent: () => import('./details-gardiennage/details-gardiennage.component').then(m => m.DetailsGardiennageComponent),
  },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
  {
    path: 'home-responsable',
    loadChildren: () => import('./home-responsable/home-responsable.module').then(m => m.HomeResponsablePageModule),
  },
  { path: 'pointeaux', loadChildren: () => import('./pointeaux/pointeaux.module').then(m => m.PointeauxModule) },
  { path: 'preferences', loadChildren: () => import('./preferences/preferences.module').then(m => m.PreferencesModule) },
  { path: 'new-info', loadChildren: () => import('./new-info/new-info.module').then(m => m.NewInfoModule) },
  {
    path: 'liste-demandes-recues',
    loadChildren: () => import('./liste-demandes-recues/liste-demandes-recues.module').then(m => m.ListeDemandesRecuesModule),
  },
  { path: 'liste-pointeaux', loadChildren: () => import('./liste-pointeaux/liste-pointeaux.module').then(m => m.ListePointeauxModule) },
  { path: 'main-courante', loadChildren: () => import('./main-courante/main-courante.module').then(m => m.MainCouranteModule) },
  {
    path: 'main-courante-item',
    loadChildren: () => import('./main-courante-item/main-courante-item.module').then(m => m.MainCouranteItemModule),
  },
  {
    path: 'main-courante-historique',
    loadChildren: () => import('./main-courante-historique/main-courante-historique.module').then(m => m.MainCouranteHistoriqueModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, paramsInheritanceStrategy: 'emptyOnly' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
